import { CwsPlanCategoryCodeComboBoxComponent } from './cws-plan-category-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';


/**
 * EC商品企画カテゴリコンボボックスモデル
 *
 * @export CwsPlanCategoryCodeComboBoxModel
 * @class CwsPlanCategoryCodeComboBoxModel
 */
export class CwsPlanCategoryCodeComboBoxModel {

  public cwsPlanCategoryList: Array<any> = Array<any>();
  public blank: boolean = <boolean>true;                                        // 先頭空白表示
  public component: CwsPlanCategoryCodeComboBoxComponent;                       // コンボボックスインスタンス
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setCategoryCode: string = <string>'';                                  // 初期設定コード値

  // Note: 以降のメンバ変数は現行で明示的な宣言無し or HTML5の移植で必要になったメンバ
  public isInitOrderCode: boolean = <boolean>false;                             // 受注コード初期化済フラグ
  public initAutoLoad: boolean = <boolean>true;                                 // 初期データ自動取得フラグ
  public setSelectedIndex: number = <number>-1;                                 // 初期設定インデックス


  /**
   * EC商品企画カテゴリ情報リストを更新する
   *
   * @param {*} serverData
   * @memberof CwsPlanCategoryCodeComboBoxModel
   */
  public updateCwsPlanCategoryList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob = {
        CategoryCode: '',
        CategoryName: '',
      };
      tempDataList.splice(index, 0, ob);
      index = 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      const categoryCode: string = tempDataList[index].CategoryCode;
      tempDataList[index].CategoryName = categoryCode.substr(0, 3) + ':' + tempDataList[index].CategoryName;
    }

    this.cwsPlanCategoryList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedCwsPlanCategoryCode();
  }

}
